import { StorageSettingsImpl } from './auth/login/types/storage-settings';
import {
	AuthGuard,
	AuthenticationService,
	ControlsModule,
	ExpansionService,
	TenantService,
	StorageSettingsToken,
	ModuleTranslateLoaderFactory,
	SuperAdminGuard,
} from 'ws-framework';
import { LOCALE_ID, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MatMenuModule } from '@angular/material/menu';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeDE from '@angular/common/locales/de';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AppSettingsService } from './service/app-settings.service';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import localePl from '@angular/common/locales/pl';
import localePlExtra from '@angular/common/locales/extra/pl';

registerLocaleData(localePl, 'pl', localePlExtra);
registerLocaleData(localeDE);

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		FormsModule,
		AppRoutingModule,
		HttpClientModule,
		MatMenuModule,
		MatSelectModule,
		MatProgressBarModule,
		MatIconModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: ModuleTranslateLoaderFactory,
				deps: [HttpClient],
			},
		}),
	],
	providers: [
		AppSettingsService,
		{ provide: LOCALE_ID, useValue: 'de-DE' },
		AuthGuard,
		AuthenticationService,
		ControlsModule,
		ExpansionService,
		TenantService,
		[{ provide: StorageSettingsToken, useClass: StorageSettingsImpl }],
		SuperAdminGuard,
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
